import { render } from "./CambioContrasena.vue?vue&type=template&id=5e587bab&scoped=true"
import script from "./CambioContrasena.vue?vue&type=script&lang=js"
export * from "./CambioContrasena.vue?vue&type=script&lang=js"

import "./CambioContrasena.vue?vue&type=style&index=0&id=5e587bab&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e587bab"]])

export default __exports__